module.exports = __webpack_public_path__ + "img/attend_event.80a67675.gif";